import { useEffect, useState, useCallback } from "react";
import * as global from '../data/global.js';
import { MuiMaterials } from '../@index.js';
import axios from "axios";
import { createApiEndpoint } from '../index.js';
import { useAuth } from "../provider/authProvider.js";

const DeviceModules = (props) => {
    // Helper function to get theme-aware colors (reads directly from global.gw.theme)
    const getThemeColor = useCallback((lightColor, darkColor) => {
        if (global.gw.theme === 'light') {
            return lightColor;
        }
        return darkColor;
    }, []);
    // const [copyMode, setCopyMode] = useState(false);

    const renderModules = () => {
        const filteredModules = (props.modules || [])
            .filter(module => module.ipAddress === props.selectedDevice)
            .sort((a, b) => a.slot - b.slot);

        // Table header: always 0-15
        const headerIndices = Array.from({ length: 16 }, (_, i) => i);

        return (
            <MuiMaterials.Box sx={{ width: '100%', overflowX: 'auto', maxHeight: '60vh' }}>
                {/* <MuiMaterials.Button
                    variant="outlined"
                    size="small"
                    sx={{ color: '#f4cc8e', borderColor: '#f4cc8e', mb: 1 }}
                    onClick={() => setCopyMode(m => !m)}
                >
                    {copyMode ? 'Exit Copy Mode' : 'Copy Table Values'}
                </MuiMaterials.Button> */}
                <MuiMaterials.Table 
                    key={`devices-table-${global.gw.theme}-${props.forceUpdate || 0}`}
                    sx={{ 
                        background: getThemeColor('#ffffff', '#2d2d2d'), 
                        color: getThemeColor('#333333', '#f4cc8e'), 
                        border: 'none', 
                        minWidth: 600, 
                        minHeight: 50 
                    }} 
                    size="small"
                >
                    <MuiMaterials.TableHead>
                        <MuiMaterials.TableRow sx={{ border: 'none' }}>
                            <MuiMaterials.TableCell 
                                sx={{ 
                                    color: getThemeColor('#333333', '#f4cc8e'), 
                                    border: 'none', 
                                    fontSize: '0.85rem', 
                                    padding: '2px' 
                                }}
                            >
                                Module
                            </MuiMaterials.TableCell>
                            {headerIndices.map((idx) => (
                                <MuiMaterials.TableCell 
                                    key={`r${idx}-header`} 
                                    sx={{ 
                                        color: getThemeColor('#333333', '#f4cc8e'), 
                                        border: 'none', 
                                        fontSize: '0.85rem', 
                                        padding: '2px', 
                                        textAlign: 'center',
                                        borderLeft: idx === 8 ? `1px solid ${getThemeColor('rgba(51, 51, 51, 0.27)', '#f4cc8e45')}` : 'none'
                                    }}
                                >
                                    {`${idx}`}
                                </MuiMaterials.TableCell>
                            ))}
                        </MuiMaterials.TableRow>
                    </MuiMaterials.TableHead>
                    <MuiMaterials.TableBody>
                        {filteredModules.map((module) => {
                            const isDO = module.moduleType === 'DO';
                            const isBRX = props.selectedDeviceType === 'BRX';
                            // If BRX and not DO, use R1-R16; if DO, use R1-R16 as checkboxes; else use R1, R3, ..., R31
                            const indices = (isDO || (isBRX && !isDO))
                                ? Array.from({ length: 16 }, (_, i) => i + 1)
                                : Array.from({ length: 16 }, (_, i) => 2 * i + 1);
                            return (
                                <MuiMaterials.TableRow key={module.id} sx={{ border: 'none' }}>
                                    <MuiMaterials.TableCell 
                                        sx={{ 
                                            color: getThemeColor('#333333', '#f4cc8e'), 
                                            border: 'none', 
                                            fontSize: '0.85rem', 
                                            padding: '2px', 
                                            fontFamily: 'inherit' 
                                        }}
                                    >
                                        {module.moduleType}
                                    </MuiMaterials.TableCell>
                                    {indices.map((idx, arrayIndex) => {
                                        const rValue = module[`r${idx}`];
                                        // if (copyMode) {
                                        //     return (
                                        //         <MuiMaterials.TableCell key={`r${idx}-cell-${module.id}`} sx={{ color: getThemeColor('#333333', '#f4cc8e'), border: 'none', fontSize: '0.85rem', padding: '2px', textAlign: 'center', fontFamily: 'monospace', userSelect: 'text' }}>
                                        //             {rValue}
                                        //         </MuiMaterials.TableCell>
                                        //     );
                                        // }
                                        if (isDO) {
                                            return (
                                                <MuiMaterials.TableCell 
                                                    key={`r${idx}-cell-${module.id}`} 
                                                    sx={{ 
                                                        color: getThemeColor('#333333', '#f4cc8e'), 
                                                        border: 'none', 
                                                        fontSize: '0.85rem', 
                                                        padding: '2px', 
                                                        textAlign: 'center',
                                                        borderLeft: arrayIndex === 8 ? `1px solid ${getThemeColor('rgba(51, 51, 51, 0.27)', '#f4cc8e45')}` : 'none'
                                                    }}
                                                >
                                                    <MuiMaterials.Checkbox
                                                        checked={!!rValue}
                                                        sx={{ 
                                                            color: getThemeColor('#333333', '#f4cc8e'), 
                                                            padding: 0,
                                                            '&.Mui-checked': {
                                                                color: getThemeColor('#333333', '#f4cc8e'),
                                                            },
                                                        }}
                                                        onChange={e => {
                                                            if (props.onModuleChange) {
                                                                props.onModuleChange(module.id, `r${idx}`, e.target.checked);
                                                            }
                                                        }}
                                                    />
                                                </MuiMaterials.TableCell>
                                            );
                                        } else {
                                            return (
                                                <MuiMaterials.TableCell 
                                                    key={`r${idx}-cell-${module.id}`} 
                                                    sx={{ 
                                                        color: getThemeColor('#333333', '#f4cc8e'), 
                                                        border: 'none', 
                                                        fontSize: '0.85rem', 
                                                        padding: '2px', 
                                                        textAlign: 'center',
                                                        borderLeft: arrayIndex === 8 ? `1px solid ${getThemeColor('rgba(51, 51, 51, 0.27)', '#f4cc8e45')}` : 'none'
                                                    }}
                                                >
                                                    <span style={{
                                                        fontSize: (rValue && rValue.toString().length > 4) ? '0.7em' : 'inherit',
                                                        color: (rValue && rValue.toString().length > 4) ? 'red' : getThemeColor('#333333', '#f4cc8e'),
                                                        wordBreak: 'break-all',
                                                        display: 'inline-block',
                                                        maxWidth: '100%'
                                                    }}>{rValue}</span>
                                                </MuiMaterials.TableCell>
                                            );
                                        }
                                    })}
                                </MuiMaterials.TableRow>
                            );
                        })}
                    </MuiMaterials.TableBody>
                </MuiMaterials.Table>
            </MuiMaterials.Box>
        );
    }

    return (
        <div
            style={props.windowStyle}
        >
            <MuiMaterials.Box
                sx={{
                    //flex: 1,
                    //padding: "10px",
                    //display: "flex",
                    //alignItems: "center",
                    fontWeight: "700",
                    //position: "absolute",
                    //left: "374px",
                    margin: "auto",
                    //textalign: "center",
                    //width: "100%",
                    //top: "-5px",
                }}
            >
                {renderModules()}
            </MuiMaterials.Box>
        </div>
    );
}
export default DeviceModules;